import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=eca3f68a&scoped=true&"
import script from "./DeleteModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=eca3f68a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca3f68a",
  null
  
)

export default component.exports